import { getCourseStatus } from '../app/scheduleModel';
import type { Course, Room } from '../app/types';

interface CourseTimelineProps {
  room?: Room;
  courses: Course[];
  now: Date;
  onPoint: (course: Course) => void;
  onAction: (course: Course) => void;
}

function getTime(value: string): string {
  return value.slice(11, 16);
}

export function CourseTimeline({ room, courses, now, onPoint, onAction }: CourseTimelineProps) {
  if (!room) return <section className="schedule-empty">请选择教室查看今日课表</section>;

  return (
    <section className="course-timeline">
      <div className="panel-title-row course-timeline__title">
        <h2 aria-label={`${room.name} 课表`}>{room.name} 课表 <small>{courses.length}节课</small></h2>
        <div className="timeline-legend" aria-label="课程时间状态">
          <span>● 已上完</span><span>● 上课中</span><span>● 等待上课</span>
        </div>
      </div>
      {courses.length === 0 ? <div className="schedule-empty">该教室今日无课</div> : null}
      <ol className="timeline-list">
        {courses.map((course) => {
          const status = getCourseStatus(course.startTime, course.endTime, now);
          return (
            <li key={course.id} className={`course-card course-card--${status}`}>
              <div className="course-time"><strong>{getTime(course.startTime)}</strong><span>{getTime(course.endTime)}</span></div>
              <i className="timeline-dot" aria-hidden="true" />
              <article>
                <div className="course-card__heading"><h3>{course.name}</h3><span>{Math.round((new Date(course.endTime).getTime() - new Date(course.startTime).getTime()) / 60000)}分钟</span></div>
                <p>任课老师：{course.teacherName}  助教：{course.assistantName}  班主任：{course.headTeacherName}</p>
                <p>已点名 · {course.attendanceCount}/{course.studentCount}人</p>
              </article>
              <div className="course-actions">
                {status === 'current' ? <button type="button" className="primary-button" onClick={() => onPoint(course)}>点名</button> : null}
                <button type="button" className="secondary-button" onClick={() => onAction(course)}>操作</button>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
